import { CommonModule } from '@angular/common';
import { Component, model } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

import { SelectedTimeReportTypeEnum } from '@app/shared/types/models/reports/time-report-panel.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'time-period-selector',
  imports: [CommonModule, MatButtonToggleModule, TranslatePipe],
  templateUrl: './time-period-selector.component.html'
})
export class TimePeriodSelectorComponent {
  protected readonly selectedTimeReportType = SelectedTimeReportTypeEnum;
  protected readonly SelectedTimeReportTypeEnum = SelectedTimeReportTypeEnum;

  protected allReports = false;

  public selectedTimeMode = model<SelectedTimeReportTypeEnum>();
}
